import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

let app = null;
let db = null;

export function initFirebase() {
  const api = localStorage.getItem('fb-api');
  const dburl = localStorage.getItem('fb-db');
  const pid = localStorage.getItem('fb-pid');
  if (!api || !dburl || !pid) return null;
  try {
    if (!app) {
      app = initializeApp({ apiKey: api, authDomain: `${pid}.firebaseapp.com`, databaseURL: dburl, projectId: pid });
    }
    db = getDatabase(app);
    return db;
  } catch (e) {
    console.error('Firebase init error:', e);
    return null;
  }
}

export function getDb() { return db; }
export { db };
